import { Language } from '../services/constants';

export const language = (state = (localStorage.getItem('applang') || Language.ENGLISH), action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      if (action.language) {
        let lang = action.language.toUpperCase();
        if (lang === Language.ENGLISH || lang === Language.FRENCH) {
          localStorage.setItem('applang', lang);
          return lang;
        }
      }
      return state;
    default:
      return state;
  }
};

export const getLanguage = (state) => state;
export const isEnglishActive = (state) => state === Language.ENGLISH;
export const isFrenchActive = (state) => state === Language.FRENCH;
